<template>
    <div class="bg-dark smaller" :style="{zIndex: 10}">
        <div class="container">
            <div class="d-flex justify-content-end">
                <a class="text-white p-2" :href="$t('help.link')" v-text="$t('help.name')" />
                <div class="text-white p-2 position-relative menu-parent">
                    <span v-text="$t('about.name')" />
                    <FontAwesomeIcon icon="chevron-down" class="chevron" />
                    <div class="sub-menu bg-white shadow-sm rounded-lg position-absolute flex-column">
                        <a v-for="(item, key) in aboutMenu"
                           :key="key"
                           class="sub-menu-link"
                           :href="item.link"
                        >
                            <span v-if="item.icon" class="sub-menu-icon-wrap">
                                <FontAwesomeIcon class="sub-menu-icon" :icon="item.icon" />
                            </span>
                            <span v-text="item.name" />
                        </a>
                    </div>
                </div>

                <div v-if="isUsertypeExpert && showLangChangeDropdown" class="text-white p-2 position-relative menu-parent">
                    <span v-text="$t('language_dropdown.name')" />
                    <FontAwesomeIcon icon="chevron-down" class="chevron" />
                    <ul class="sub-menu bg-white shadow-sm rounded-lg position-absolute flex-column list-unstyled">
                        <li v-for="lang in languagesDropdown" :key="lang" class="sub-menu-link">
                            <a class="sub-menu-link" :href="`/change-language-to-${lang}`">
                                <LanguageFlag :language="lang" class="language-flag" />
                                {{ $t(`language_dropdown.${lang}`) }}
                            </a>
                        </li>
                    </ul>
                </div>
                <a v-if="isImpersonated() && user" class="text-white p-2 impersonate" :href="user.links.exit_impersonate">
                    <FontAwesomeIcon icon="user-secret" />
                    <FontAwesomeIcon icon="sign-out-alt" />
                </a>
                <div v-if="user" class="text-white p-2 position-relative menu-parent">
                    <span v-text="$t('my-account.name')" />
                    <FontAwesomeIcon icon="chevron-down" class="chevron" />
                    <div class="sub-menu bg-white shadow-sm rounded-lg position-absolute flex-column">
                        <a v-for="(item, key) in accountMenu"
                           :key="key"
                           class="sub-menu-link"
                           :href="item.link"
                        >
                            <span v-if="item.icon" class="sub-menu-icon-wrap">
                                <FontAwesomeIcon class="sub-menu-icon" :icon="item.icon" />
                            </span>
                            <span v-text="item.name" />
                        </a>
                    </div>
                </div>
                <a v-if="!user" class="text-white p-2" :href="'/login'">
                    <span v-text="$t('login.name')" />
                    <FontAwesomeIcon icon="user-circle" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import LanguageFlag from '../Flag/LanguageFlag';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import loadTranslations from '../../js/Functions/loadTranslations';
import {
    faChevronDown,
    faUserSecret,
    faSignOutAlt,
    faUserCircle,
} from '@fortawesome/free-solid-svg-icons';

import { library } from '@fortawesome/fontawesome-svg-core';
library.add(faChevronDown, faUserSecret, faSignOutAlt, faUserCircle);

export default {
    i18n: {
        messages: loadTranslations('top_menu'),
    },
    components: { FontAwesomeIcon, LanguageFlag },
    props: {
        accountMenu: {
            type: Array,
            required: true,
            default: () => [],
        },
        user: {
            type: Object,
            required: false,
            default: () => {},
        },
        isUsertypeExpert: {
            type: Boolean,
            required: false,
            default: false,
        },
        showLangChangeDropdown: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        let aboutMenu = [
            {
                name: this.$i18n.t(`editors.name`),
                link: this.$i18n.t(`editors.link`),
            },
            {
                name: this.$i18n.t(`team.name`),
                link: this.$i18n.t(`team.link`),
            },
            {
                name: this.$i18n.t(`jobs.name`),
                link: this.$i18n.t(`jobs.link`),
            },
            {
                name: this.$i18n.t(`contact.name`),
                link: this.$i18n.t(`contact.link`),
            },
        ];

        if (this.isUsertypeExpert) {
            aboutMenu.splice(1, 0, {
                name: this.$i18n.t(`apply_as_editor.name`),
                link: this.$i18n.t(`apply_as_editor.link`),
            });
        }

        let languagesDropdown = ['nl', 'us', 'de', 'es', 'fr', 'it', 'dk', 'no', 'se', 'fi'];

        return { aboutMenu, languagesDropdown };
    },
    methods: {
        isImpersonated() {
            return this.user && this.user.links.exit_impersonate;
        },
    },

};
</script>

<style scoped lang="scss">
  @import '../../scss/variables';

  .chevron {
        font-size: .6em;
        position: relative;
        top: -.2em;
    }
    .sub-menu {
        top: 2.4rem;
        right: 0;
        display: none;
        width: max-content;
        min-width: 16.875rem;
        padding: 1rem 1.5rem;
        z-index: 9;
    }

    .sub-menu-link {
      color: $dark;
      padding-top: .5rem;
      padding-bottom: .5rem;
    }

    .sub-menu-icon-wrap {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        background: $gray-200;
        border-radius: 50%;
        text-align: center;
        padding-top: .275rem;
        margin-right: 1rem;
    }

    .sub-menu-icon {
        color: $text-muted;
        font-size: 1rem;
        line-height: 2rem;
    }

    .menu-parent:hover {
        cursor: pointer;
    }

    .menu-parent:hover .sub-menu {
        display: flex;
    }
    .impersonate {
      background: rgba($red,.4);
      text-decoration: none;
    }
    .impersonate:hover {
      background: rgba($red,.6);
      color: #fff;
    }
    .language-flag {
        max-width: 1.25rem;
        margin-right: 0.25rem;
    }
</style>
